module.exports = __webpack_public_path__ + "static/img/wisdomsuccess1.f72c8d6f.png";